import Request from "utils/requests/api";
import initializeConfig from "utils/requests/api.config";

export const BASE_URL_IDENTITY = async () => {
  const { identity } = await initializeConfig();
  return `${identity}`;
};

export interface IRequestUsers {
  filter: string;
  orderBy: string;
  ascending: boolean;
  _size: number;
  _page: number;
}

export type ILocation = {
  id: number;
  description: string;
};

export interface IRequestUpdateUser {
  id: number;
  roleId: number;
  location: ILocation;
  jobTitle: string;
  language: string;
  locations: ILocation[];
  allowMultipleLocations: boolean;
}

export const getUsers = async ({ filter, orderBy, ascending, _size, _page }: IRequestUsers) => {
  const baseUrlIdentity = await BASE_URL_IDENTITY();
  return (await Request).get(`${baseUrlIdentity}users:paginated`, {
    filter,
    orderBy,
    ascending,
    _size,
    _page,
  });
};

export const getRoles = async () => {
  const baseUrlIdentity = await BASE_URL_IDENTITY();
  return (await Request).get(`${baseUrlIdentity}roles`);
};

export const getUserById = async ({ id }) => {
  const baseUrlIdentity = await BASE_URL_IDENTITY();
  return (await Request).get(`${baseUrlIdentity}users/${id}`);
};

export const updateUser = async ({ id, roleId, location, jobTitle, locations, language, allowMultipleLocations }: IRequestUpdateUser) => {
  const baseUrlIdentity = await BASE_URL_IDENTITY();
  return (await Request).put(`${baseUrlIdentity}users`, {
    id,
    roleId,
    location,
    jobTitle,
    locations,
    language,
    allowMultipleLocations,
  });
};
